import api from '../services/api';

export interface GroupMemberOption {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  role: string;
}

/**
 * Fetch assignment-group members for the Assign To dropdown.
 * When customerId is provided, the backend applies the customer's assignToUserScope filter.
 */
export async function fetchAssignmentGroupMembers(
  groupId: string,
  customerId?: string | null
): Promise<GroupMemberOption[]> {
  const params = customerId ? { customerId } : undefined;
  const response = await api.get(`/groups/${groupId}/members`, { params });
  return response.data;
}
